
export function Toast({ title, message, toastType, onCloseClick }: { title: string, message: string, toastType: string, onCloseClick: () => void }) {
    const toastClassName = () => {
        var toastClassName = "toast-message";
        switch (toastType.toLowerCase()) {
            case "error": 
                toastClassName = "toast-error";
                break;
            case "warning":
                toastClassName = "toast-warning";
                break;
            case "success":
                toastClassName = "toast-success";
                break;
            default:
                break;
        }
        return toastClassName;
    }
    return (
        <div className={"border relative right-0 w-[300px] p-2 m-2 z-10 rounded-lg " + toastClassName()} >
            <div className="absolute right-2 top-0 cursor-pointer" onClick={onCloseClick}>x</div>
            <span className="text-sm">{title}</span>
            <p className="text-xs">{message}</p>
            
        </div>
    )
}